import { Ionicons } from '@expo/vector-icons';
import { Alert, Platform, Pressable, Text, View } from 'react-native';
import { useState } from 'react';

interface ReviewHintIconProps {
  onPress: () => void;
  tooltip?: string;
}

const DEFAULT_TOOLTIP = 'Account type needs review';

export function ReviewHintIcon({
  onPress,
  tooltip = DEFAULT_TOOLTIP,
}: ReviewHintIconProps) {
  const [showTooltip, setShowTooltip] = useState(false);
  const isWeb = Platform.OS === 'web';

  return (
    <View className="relative">
      <Pressable
        accessibilityRole="button"
        accessibilityLabel={tooltip}
        accessibilityHint="Opens account type review"
        hitSlop={8}
        onHoverIn={isWeb ? () => setShowTooltip(true) : undefined}
        onHoverOut={isWeb ? () => setShowTooltip(false) : undefined}
        onFocus={() => setShowTooltip(true)}
        onBlur={() => setShowTooltip(false)}
        onLongPress={
          isWeb
            ? undefined
            : () => Alert.alert('Account type needs review', tooltip)
        }
        onPress={(event) => {
          event.stopPropagation?.();
          setShowTooltip(false);
          onPress();
        }}
        className="rounded-full p-1 active:opacity-70 web:cursor-pointer hover:bg-amber-50"
      >
        {({ pressed }) => (
          <View className={pressed ? 'opacity-80' : ''}>
            <Ionicons
              name="help-circle-outline"
              size={16}
              color={showTooltip || pressed ? '#b45309' : '#d97706'}
            />
          </View>
        )}
      </Pressable>

      {isWeb && showTooltip ? (
        <View className="absolute right-0 bottom-7 z-50 max-w-44 rounded-md border border-amber-200 bg-white px-2 py-1 shadow-sm">
          <Text className="text-[11px] leading-4 text-gray-700">{tooltip}</Text>
        </View>
      ) : null}
    </View>
  );
}
